import { OpenAPI, PaymentMethodVM } from "@propertelligent/client-api";
import { UserLoginData } from "../../common/charts/Enums";

/**
 * Raw-fetch bridge to the platform payment-method list endpoint.
 *
 * The typed client method (PaymentService.getApiPaymentMethodPlatformList) does not exist until CI regenerates
 * @propertelligent/client-api, so the platform Payment Accounts screen reaches the new
 * /api/PaymentMethod/plaid-payment-method/platform-list endpoint through this single helper. Centralizing it here
 * keeps the component presentational and gives one place to swap in the typed client method after regen.
 *
 * TODO: replace the fetch below with PaymentService.getApiPaymentMethodPlatformList once client-api is regenerated.
 *
 * Returns the platform payment methods, or an empty array when the endpoint responds with a non-ok status.
 * Network/parse failures are surfaced by throwing so the caller can decide how to present the error.
 */
export const fetchPlatformPaymentMethodList = async (): Promise<PaymentMethodVM[]> => {
  const token = sessionStorage.getItem(UserLoginData.token);
  const response = await fetch(
    `${OpenAPI.BASE}/api/PaymentMethod/plaid-payment-method/platform-list`,
    { method: "GET", headers: { Authorization: `Bearer ${token}` } }
  );
  if (!response.ok) {
    return [];
  }
  const data = await response.json();
  return data?.success ?? [];
};
